import { LogoDimensions } from './types';

export const CENTERED_CONTENT_MAX_WIDTH = 1320;
export const LOGO_MIN_WIDTH = 265;
export const MINIMUM_NUMBER_OF_LOGOS = 4;

export const LOGO_DIMENSIONS = { width: LogoDimensions.width, height: LogoDimensions.height };

export const IN_VIEW_CONFIG = {
  threshold: 0,
  triggerOnce: true,
  rootMargin: '200px',
};
